import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MapProvider } from 'planning-portal-library/src/lib/core/domain/models/map-provider.model';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { MapProviderRepository } from 'planning-portal-library/src/lib/core/repositories/map-provider.repository';
import { catchError, map, Observable } from 'rxjs';
import { BaseResponse } from '../../shared/base.response';
import { MapProviderWebEntity } from './entities/map.web-entity';
import { MapProviderWebRepositoryMapper } from './entities/map.web-repository-mapper';
import { MapProviderApiUrls } from './map-providers-api-urls';

@Injectable({ providedIn: 'root' })
export class MapProviderWebRepository extends MapProviderRepository {
  mapProviderMapper = new MapProviderWebRepositoryMapper();
  environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getMapProviders(): Observable<MapProvider[]> {
    return this.http
      .get<BaseResponse<MapProviderWebEntity[]>>(
        `${this.environment.url}${MapProviderApiUrls.GetMapProvider}`
      )
      .pipe(
        map((data: BaseResponse<MapProviderWebEntity[]>) => {
          if (!Array.isArray(data.result)) {
            return [];
          }
          return data.result;
        }),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map((items) => items.map(this.mapProviderMapper.mapFrom)));
  }
}
